module.exports = __webpack_public_path__ + "static/img/cus_13_pre.8e68ac76.jpg";